<template>
  <transition name="modal-backdrop-transition" appear>
    <div class="o-backdrop">
      <div class="modal">
        <div class="shopping-setup">
          <header class="shopping-setup__header">
            <img src="@/assets/images/icon-customize-colored.svg" class="shopping-setup__header-icon">

            <div class="shopping-setup__header-content">
              <h4 class="shopping-setup__header-title">Präsent-Konfigurator</h4>
              <p class="shopping-setup__header-description">Wichtige Angaben für Ihr maßgeschneidertes Präsent.</p>
            </div>
          </header>

          <content class="shopping-setup__content">
            <!-- how many presents? -->
            <div class="grid u-grid-medium-gutter">
              <div class="col-12">
                <FormLabel>
                  Wieviele Präsentboxen benötigen Sie? <Popper trigger="hover"><div class="u-dp-inline-block u-ml-2"><span class="shopping-setup__help-icon"><i class="icon icon-question-circle"></i></span></div> <template v-slot:popover>Verfügbarkeiten, Lieferzeiten und mögliche Zusatz-Services sind von Ihrer benötigten Menge abhängig. Sie können die hier gewählte Stückzahl später bei Bedarf ändern.</template></Popper>
                </FormLabel>

                <div class="u-dp-flex u-align-items-center">
                  <Button
                    @click="quantity = 1; submit()"
                    :appearance="'secondary ' + (quantity === 1 ? 'active' : '')"
                  >
                    1 Präsent
                  </Button>

                  <span class="u-text-muted u-ml-2 u-mr-2">oder</span>

                  <Button
                    @click="multiplePresents = true"
                    :appearance="'secondary ' + (multiplePresents ? 'active' : '')"
                  >
                    Mehrere Präsente
                  </Button>
                </div>
              </div>
              <!-- /how many presents? -->

              <!-- do you know the quantity? -->
              <transition name="shopping-setup__question-transition">
                <div v-if="multiplePresents" class="col-12">
                  <FormLabel>
                    Kennen Sie bereits die <b>exakt</b> benötigte Stückzahl?
                  </FormLabel>

                  <div class="u-dp-flex u-align-items-center">
                    <Button
                      @click="exactQuantity = true"
                      :appearance="'secondary ' + (exactQuantity ? 'active' : '')"
                    >
                      Ja
                    </Button>

                    <Button
                      @click="exactQuantity = false"
                      :appearance="'secondary ' + (exactQuantity == false ? 'active' : '')"
                    >
                      Nein
                    </Button>

                    <Popper trigger="hover"><div class="u-dp-inline-block u-ml-2"><span class="shopping-setup__help-icon"><i class="icon icon-question-circle"></i></span></div> <template v-slot:popover>Verfügbarkeiten, Lieferzeiten und mögliche Zusatz-Services sind von Ihrer benötigten Menge abhängig. Sie können die hier gewählte Stückzahl später bei Bedarf ändern.</template></Popper>
                  </div>
                </div>
              </transition>
              <!-- /do you know the quantity? -->

              <!-- exact quantity -->
              <transition name="shopping-setup__question-transition">
                <div v-if="exactQuantity === true" class="col-12">
                  <FormLabel for="shopping-setup-quantity">
                    Stückzahl eingeben
                  </FormLabel>

                  <FormInput
                    id="shopping-setup-quantity"
                    type="number"
                    v-model="quantity"
                    min="2"
                    max="1000"
                    display="inline-block"
                    class="shopping-setup__quantity-input"
                  />

                  <Popper trigger="hover"><div class="u-dp-inline-block u-ml-2"><span class="shopping-setup__help-icon"><i class="icon icon-question-circle"></i></span></div> <template v-slot:popover>Verfügbarkeiten, Lieferzeiten und mögliche Zusatz-Services sind von Ihrer benötigten Menge abhängig. Sie können die hier gewählte Stückzahl später bei Bedarf ändern.</template></Popper>
                </div>
              </transition>
              <!-- exact quantity -->

              <!-- quantity slider -->
              <transition name="shopping-setup__question-transition">
                <div v-if="exactQuantity === false" class="col-12">
                  <FormLabel>
                    Mengenbereich auswählen <Popper trigger="hover"><div class="u-dp-inline-block u-ml-2"><span class="shopping-setup__help-icon"><i class="icon icon-question-circle"></i></span></div> <template v-slot:popover>Verfügbarkeiten, Lieferzeiten und mögliche Zusatz-Services sind von Ihrer benötigten Menge abhängig. Sie können die hier gewählte Stückzahl später bei Bedarf ändern.</template></Popper>
                  </FormLabel>

                  <vue-slider
                    ref="quantityRangeSlider"
                    class="shopping-setup__slider"
                    v-model="quantityRange.value"
                    :marks="quantityRange.ranges"
                    :included="true"
                    :enable-cross="false"
                    :tooltip="'none'"
                    @change="changeQuantityRange()"
                  ></vue-slider>
                </div>
              </transition>
              <!-- quantity slider -->

              <!-- delivery slider -->
              <transition name="shopping-setup__question-transition">
                <div v-if="quantity >= 20" class="col-12">
                  <FormLabel>Gewünschte Lieferzeit <Popper trigger="hover"><div class="u-dp-inline-block u-ml-2"><span class="shopping-setup__help-icon"><i class="icon icon-question-circle"></i></span></div> <template v-slot:popover>Sofern bekannt können Sie hier Ihre gewünschte Lieferzeit eintragen. Unser Konfigurator zeigt entsprechend nur die Präsente oder Delikatessen an, welche innerhalb dieser Lieferfrist verfügbar sind.</template></Popper></FormLabel>

                  <vue-slider
                    ref="deliveryRangeSlider"
                    class="shopping-setup__slider"
                    v-model="deliveryRange.value"
                    :marks="deliveryRange.ranges"
                    :included="true"
                    :enable-cross="false"
                    :tooltip="'none'"
                    @change="changeDeliveryRange()"
                  ></vue-slider>
                </div>
              </transition>
              <!-- delivery slider -->

              <!-- level options -->
              <!-- <div
                v-if="$store.getters.getRedirectCon"
                class="col-12"
              >
                <FormLabel>
                  Wähle eine Option
                </FormLabel>

                <div
                  class="shopping-setup__level"
                  @click="level = 1"
                >
                  <img src="@/assets/images/shopping-setup-level1.png" class="shopping-setup__level-photo">

                  <div class="shopping-setup__level-info">
                    <FormInput ref="level1Option" id="level1-option" type="radio" name="level" value="1" :checked="level === 1">Fertige Präsente</FormInput>

                    <p>Eine Vielzahl vorverpackter Präsente, die zu jedem Budget und Geschmack passen.</p>
                  </div>
                </div>

                <div
                  class="shopping-setup__level"
                  @click="level = 3"
                >
                  <img src="@/assets/images/shopping-setup-level3.png" class="shopping-setup__level-photo">

                  <div class="shopping-setup__level-info">
                    <FormInput ref="level3Option" id="level3-option" type="radio" name="level" value="3" :checked="level === 3">Präsent Erstellen</FormInput>

                    <p>Definieren Sie jede Delikatesse selbst. Gestalten Sie Ihre individuelle Präsent ganz nach Ihren Wünschen!</p>
                  </div>
                </div>
              </div> -->
              <!-- /level options -->

              <!-- submit area -->
              <transition name="shopping-setup__question-transition">
                <div
                  v-if="quantity > 0"
                  class="col-12 shopping-setup__submit-area"
                >
                  <Button type="submit" class="shopping-setup__submit-btn" appearance="primary" @click="submit()">Präsente anzeigen</Button>
                </div>
              </transition>
              <!-- /submit area -->
            </div>
          </content>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';
import FormLabel from '@/components/Common/FormLabel.vue';
import Button from '@/components/Common/Button';
import FormInput from '@/components/Common/FormInput';
import Popper from '@/components/Popper';

export default {
  name: 'ShoppingSetupModal',
  mixins: [logicMixin],
  components: {
    FormLabel,
    FormInput,
    Button,
    Popper
  },
  data () {
    return {
      level: 1,
      multiplePresents: null,
      exactQuantity: null,
      quantity: 0,
      deliveryTime: -1,
      quantityRange: {
        value: 0,
        min: 0,
        max: 100,
        ranges: {
          0: '',
          10: '2-19',
          30: '20-50',
          50: '51-150',
          76: '151-500',
          100: '501+'
        },
        rangesMap: {
          0: 0,
          10: 19,
          30: 50,
          50: 150,
          76: 500,
          100: 800
        }
      },
      deliveryRange: {
        value: 0,
        min: 0,
        max: 100,
        ranges: {
          0: '',
          10: 'Sofort',
          30: '5 Werktage',
          55: '2 Wochen',
          80: '3 Wochen',
          100: '4+ W'
        },
        rangesMap: {
          0: 0,
          10: 2,
          30: 5,
          55: 11,
          80: 16,
          100: 0
        }
      }
    };
  },
  methods: {
    changeQuantityRange () {
      this.quantity = this.quantityRange.rangesMap[this.quantityRange.value];
    },

    changeDeliveryRange () {
      this.deliveryTime = this.deliveryRange.rangesMap[this.deliveryRange.value];
    },

    submit () {
      this.boxQty = this.quantity;
      this.$store.commit('setLevel1FilterB2bQty', this.quantity);
      this.$store.commit('setLevel3FilterB2bQty', this.quantity);
      this.$store.commit('setLevel1FilterB2bTime', this.deliveryTime);
      this.$store.commit('setLevel3FilterB2bTime', this.deliveryTime);

      if (this.$store.getters.getRedirectCon && this.level === 3) {
        this.$router.push(this.cLink('/zusammenstellen'));
      }
      this.$root.$emit('closeSetupModal');
    }
  },
  mounted () {
    document.querySelector('body').style.setProperty('overflow', 'hidden');
  },
  destroyed () {
    document.querySelector('body').style.removeProperty('overflow');
  }
};
</script>

<style lang="scss" scoped>
/**
 * ShoppingSetupModal
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Modal for setting shopping values (as quantity and delivery date)
 * @since 2021-05-13
**/

$component: 'shopping-setup';

.#{$component} {
  max-width: 26rem;
  @include padding(map-get($spacers, 4));

  // ::v-deep {
  //   .btn {
  //     display: inline-block;
  //   }
  // }

  &__header {
    display: flex;
    align-items: flex-start;
    @include margin-bottom(map-get($spacers, 5));

    &-icon {
      @include rfs(4.4rem, width);
      @include margin-top(map-get($spacers, 1));
      @include margin-right(map-get($spacers, 3));
    }

    &-title {
      @include margin(0 0 map-get($spacers, 2) 0);
    }

    &-description {
      margin: 0;
      color: $ink-lighter;
    }
  }

  &__content {

  }

  &__quantity-input {
    width: 80px !important;
  }

  &__help-icon {
    vertical-align: middle;
    @include font-size($font-size-xl);
    color: $text-muted;
  }

  &__slider {
    ::v-deep {
      padding-bottom: $font-size-base * 2 !important;

      .vue-slider {
        &-marks {
          width: 94%;
          margin-left: 5px;
        }

        &-mark-label {
          color: $ink-lighter;
          @include font-size($font-size-sm);

          &-active {
            // font-weight: $font-weight-bold;
          }
        }
      }
    }
  }

  &__level {
    display: flex;
    align-items: flex-start;
    cursor: pointer;

    & + & {
      @include margin-top(map-get($spacers, 2));
    }
  }

  &__level-photo {
    @include rfs(7rem, width);
    @include margin-right(map-get($spacers, 4));
  }

  &__level-info {
    ::v-deep label {
      font-weight: $font-weight-bold;
    }

    p {
      @include margin(map-get($spacers, 1) 0 0 0);
      color: $ink-lighter;
      @include font-size($font-size-sm);
    }
  }

  &__submit-area {
    @include margin-top(map-get($spacers, 3));
    padding-bottom: 0 !important;
  }

  &__submit-btn {
    width: 100%;
  }

  // Transition
  &__question-transition {
    &-enter-active,
    &-leave-active {
      max-height: 100px;
      transition: opacity 0.2s, max-height 0.2s;
      opacity: 1;
      will-change: max-height;
    }

    &-enter,
    &-leave-to {
      max-height: 0;
      opacity: 0;
    }
  }
}
</style>
